import React from 'react';
import { ColorType, Icon, Label, LabelType } from '..';
import { Info } from '../../../assets/icons';
import { IconSize } from '../../../constant/IconSize.constant';

interface WarningMessageProps {
  text: any;
  iconSize?: any;
  divClassName?: string;
}

export const WarningMessage: React.FC<WarningMessageProps> = ({ text, iconSize = IconSize.SIZE_16x16, divClassName = 'items-center' }) => {
  return (
    <div className={`w-full flex rounded p-2 gap-2 rounded-lg bg-grey0 border-grey3 border-2 ${divClassName}`}>
      <Icon src={Info} size={iconSize} />
      <Label text={text} type={LabelType.BODY4} color={ColorType.GREY6} />
    </div>
  );
};
